import builder from '../builder';
import MessagesBubbleText1 from '../../streamline-icons/light/messages-bubble-text-1.svg';

export default builder('IconMessagesBubbleText1Light', MessagesBubbleText1);
